import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { Stars } from "@/components/Stars";

export default function AdminReviews() {
  const [list, setList] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Eliminare questa recensione?")) return;
    await api.delete(`/admin/reviews/${id}`);
    toast.success("Recensione eliminata");
    load();
  };

  return (
    <div className="space-y-6" data-testid="admin-reviews">
      <div>
        <span className="tag text-[#0033FF]">Fiducia</span>
        <h1 className="font-display font-black text-4xl tracking-tight">Recensioni</h1>
        <p className="text-sm text-[#555] mt-1">Solo i clienti con ordine consegnato possono recensire. Le recensioni vengono pubblicate subito.</p>
      </div>
      <div className="border border-[#0F0F0F] bg-white divide-y divide-[#0F0F0F]/15">
        {list.length === 0 && <p className="p-4 text-sm text-[#555]" data-testid="reviews-empty">Nessuna recensione.</p>}
        {list.map((r) => (
          <div key={r.id} className="p-4 flex gap-4 items-start" data-testid={`admin-review-${r.id}`}>
            <div className="flex-1 space-y-1">
              <div className="flex items-center gap-3">
                <Stars value={r.rating} />
                <span className="text-sm font-medium">{r.product_title}</span>
              </div>
              <p className="text-sm">{r.comment}</p>
              <p className="font-mono text-xs text-[#555]">{r.author} · {r.order_code} · {new Date(r.created_at).toLocaleString("it-IT")}</p>
            </div>
            <button data-testid={`delete-review-${r.id}`} onClick={() => del(r.id)} className="p-1.5 hover:text-[#FF3333]"><Trash2 size={15} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
